// import axios from "./APIUtils";
import axios from "./axios.provider";
import { apiConfig } from "./config";
// import { parseBlob } from "./utility";

const GetBlob = async function(blobName) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Blob/GetBlob/${blobName}`
    );
    // let data = parseBlob(response);
    return response;
  } catch (error) {
    console.log(error);
  }
};

const GetBlob2 = async function(blobName) {
  try {
    axios({
      url: `${apiConfig}/api/Blob/GetBlob/${blobName}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", blobName);
      document.body.appendChild(fileLink);

      fileLink.click();
    });
  } catch (error) {
    console.log(error);
  }
};

export const _blobservice = {
  GetBlob,
  GetBlob2,
};
